import { render } from "./EmptyCard.vue?vue&type=template&id=4bc3d14f&scoped=true"
import script from "./EmptyCard.vue?vue&type=script&lang=js"
export * from "./EmptyCard.vue?vue&type=script&lang=js"

import "./EmptyCard.vue?vue&type=style&index=0&id=4bc3d14f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc3d14f"]])

export default __exports__